import script from "./FAQ2.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQ2.vue?vue&type=script&setup=true&lang=js"

import "./FAQ2.vue?vue&type=style&index=0&id=62fa488a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62fa488a"]])

export default __exports__